import { render, staticRenderFns } from "./PopulateDynamically.vue?vue&type=template&id=5f6ad8fc&"
import script from "./PopulateDynamically.vue?vue&type=script&lang=ts&"
export * from "./PopulateDynamically.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports